<div class="row">
  <div class="col">
    <p-dialog [(visible)]="showCoilComparisonDialog" [style]="{width: '95%', height: '95%'}" [modal]="true" (onHide)="onClose()">
      <ng-template pTemplate="header" class="bg-primary">
        <div class="compare-coils m-2">Compare coils</div>
      </ng-template>
      <p-splitter styleClass="mb-1 sec-h" layout="vertical"  [style]="{ 'height': '99%' }">
        <ng-template pTemplate>
          <section class="px-3 h-100" style="margin: 1rem;">
            <div class="row h-100">
              <div class="col" style="height: 290px">
                <div class="selected-coils col text-nowrap">Selected coils</div>
                <ag-grid-angular
                  style="height: 90%; border: 0; "
                  class="ag-theme-quartz"
                  [rowData]="selectedCoilsData"
                  [columnDefs]="colDefs">
                </ag-grid-angular>
              </div>
            </div>
          </section>
        </ng-template>
        <ng-template pTemplate>
          <section class="px-3" style="height: 60%; margin: 1rem;">
            <div class="row mb-3">
              <div class="comparison col text-nowrap">Comparison</div>
              <div class="col d-flex gap-2 justify-content-end">
                  <app-dropdown-button [defaultSelection]="selectedGraph.label" [dropList]="availableGraphs" (selectElement)="onSelectGraphEvent($event)"></app-dropdown-button>
              </div>
            </div>
            <!-- Graph -->
            <div class="row">
              <div class="col">
                  <div id="chart11">
                      @if(showCoilComparisonDialog && selectedCoils && chartOptions1) {
                          <apx-chart
                              [series]="chartOptions1.series"
                              [chart]="chartOptions1.chart"
                              [xaxis]="chartOptions1.xaxis"
                              [yaxis]="chartOptions1.yaxis"
                              [colors]="chartOptions1.colors"
                              [fill]="chartOptions1.fill"
                              [markers]="chartOptions1.markers"
                              [stroke]="chartOptions1.stroke"
                              [responsive]="chartOptions1.responsive"
                              [legend]="chartOptions1.legend"
                          ></apx-chart>
                      }
                  </div>
                  
                  <div id="chart22">
                      @if(showCoilComparisonDialog && selectedCoils && chartOptions2) {
                          <apx-chart
                              [series]="chartOptions2.series"
                              [chart]="chartOptions2.chart"
                              [xaxis]="chartOptions2.xaxis"
                              [colors]="chartOptions2.colors"
                              [fill]="chartOptions2.fill"
                              [yaxis]="chartOptions2.yaxis"
                               [legend]="chartOptions2.legend"
                          ></apx-chart>
                      }
                  </div>
              </div>
          </div>
          </section>
        </ng-template>
      </p-splitter>
    </p-dialog>
  </div>
</div>